import { createContext } from 'react'

import { TSessionDetails, TSignoutContext } from '~/features/auth/models'

export const SignoutContext = createContext<TSignoutContext | null>(null)

export const EMPTY_SESSION: TSessionDetails = {
  groups: [],
  email: '',
  cognitoUid: '',
  accessToken: '',
}

export const ABC_FITNESS_AUTH_FEATURES_LINK =
  'https://abcfitness.com/demo/ai-agents/'

/** Shown when Cognito sign-in succeeds but there is no app user (invite-only). */
export const UNREGISTERED_SIGN_IN_MESSAGE =
  "We couldn't find an account for you. Book a demo to get started."
